import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { Location } from '../location.model';
import { LocationService } from '../location.service';

import { Organization } from '../../organization/organization.model';
import { OrganizationService } from '../../organization/organization.service';

@Component({
  selector: 'app-location-edit',
  templateUrl: './location-edit.component.html',
  styleUrls: ['./location-edit.component.scss']
})
export class LocationEditComponent implements OnInit {

  public locationId: number;
  public location: Location;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public locationService: LocationService,
    public organizationService: OrganizationService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      if (params.location_id) {
        this.locationId = params.location_id;
        this.location = this.locationService.location(this.locationId);
        console.log(this.location);
        if (!this.location) this.router.navigate(['../locations']);
      } else {
        this.router.navigate(['../locations']);
      }
    })
  }

  submitForm() {
    this.locationService.saveLocation(this.location);
    this.router.navigate(['../locations/']);
  }

}
